var _rect, _rect2, _rect3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVippsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 32,
    viewBox: "0 0 48 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 32,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 32,
    rx: 3.5,
    fill: "#FF5B24"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 42,
    height: 27,
    rx: 13.5,
    fill: "#FF5B24"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8641 12.2624C29.2412 12.2624 30.4213 11.217 30.4213 9.71443H30.4216C30.4216 8.21146 29.2412 7.16643 27.8641 7.16643C26.4875 7.16643 25.3077 8.21146 25.3077 9.71443C25.3077 11.217 26.4875 12.2624 27.8641 12.2624ZM31.2079 16.3793C29.5029 18.6003 27.7 20.1359 24.52 20.1359H24.5204C21.276 20.1359 18.7513 18.1757 16.7846 15.301C15.9976 14.1247 14.7847 13.8635 13.8995 14.4843C13.0801 15.0724 12.8839 16.3139 13.6374 17.3922C16.358 21.5412 20.1276 23.9582 24.52 23.9582C28.5525 23.9582 31.6996 21.9984 34.1578 18.7313C35.0754 17.5228 35.0427 16.2813 34.1578 15.5951C33.338 14.9411 32.1252 15.1708 31.2079 16.3793Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVippsIcon);
export default __webpack_public_path__ + "static/media/vipps-icon.09166c76975924f3af5571dffbe89deb.svg";
export { ForwardRef as ReactComponent };